/** Count each stat once on entry, preserving its final wording and number format. */
(function () {
  if (window.lnvcStatsCountupInitialized) return;
  window.lnvcStatsCountupInitialized = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var initialized = new WeakSet();

  function parseTarget(text) {
    var match = text.match(/^([^0-9]*)([0-9](?:[0-9\s.,]*[0-9])?)(.*)$/);
    if (!match) return null;
    var raw = match[2];
    var decimal = raw.match(/([.,])(\d{1,2})$/);
    var integer = decimal ? raw.slice(0, decimal.index) : raw;
    var group = integer.match(/[^0-9]/);
    var number = Number(integer.replace(/[^0-9]/g, '') + (decimal ? '.' + decimal[2] : ''));
    if (!Number.isFinite(number)) return null;
    return {
      number: number,
      prefix: match[1],
      suffix: match[3],
      decimals: decimal ? decimal[2].length : 0,
      decimal: decimal ? decimal[1] : '',
      group: group ? group[0] : '',
      original: text
    };
  }

  function formatValue(value, target) {
    var parts = value.toFixed(target.decimals).split('.');
    if (target.group) parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, target.group);
    return target.prefix + parts.join(target.decimal) + target.suffix;
  }

  function animateValue(element, target) {
    var start = performance.now();
    element.textContent = formatValue(0, target);
    function tick(now) {
      var progress = Math.min((now - start) / 1500, 1);
      if (progress >= 1 || reducedMotion.matches) {
        element.textContent = target.original;
        return;
      }
      var eased = 1 - Math.pow(1 - progress, 3);
      element.textContent = formatValue(eased * target.number, target);
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initCountUp(container) {
    if (reducedMotion.matches || !('IntersectionObserver' in window)) return;
    var targets = new Map();
    container.querySelectorAll('.stats-block [data-countup]').forEach(function (element) {
      if (initialized.has(element)) return;
      initialized.add(element);
      var target = parseTarget(element.textContent.trim());
      if (target) targets.set(element, target);
    });
    if (!targets.size) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (!reducedMotion.matches) animateValue(entry.target, targets.get(entry.target));
        targets.delete(entry.target);
      });
      if (!targets.size) observer.disconnect();
    }, { threshold: 0.3 });
    targets.forEach(function (_, element) { observer.observe(element); });
  }

  initCountUp(document);
  document.addEventListener('shopify:section:load', function (event) {
    initCountUp(event.target);
  });
})();
